import React from 'react';
import { WorkflowStrip } from '@/components/enterprise';

export interface EpcEstimateWorkflowStripProps {
  revisionStatus?: string | null;
  costModel?: string | null;
  pricing?: string | null;
  approved?: boolean;
}

export const EpcEstimateWorkflowStrip: React.FC<EpcEstimateWorkflowStripProps> = ({
  revisionStatus,
  costModel,
  pricing,
  approved,
}) => {
  const status = String(revisionStatus || 'Draft');
  const costReady = costModel === 'READY';
  const pricingReady =
    pricing === 'READY' || pricing === 'IN_PROGRESS' || String(pricing || '').includes('READY');

  let current = 0;
  if (status !== 'Draft') current = 1;
  if (costReady) current = 2;
  if (pricingReady) current = 3;
  if (status === 'UnderReview') current = 4;
  if (approved) current = 5;

  return (
    <WorkflowStrip
      current={current}
      compact
      stages={[
        { title: 'Draft' },
        { title: 'Building' },
        { title: 'Cost ready' },
        { title: 'Pricing' },
        { title: 'Review' },
        { title: 'Approved' },
      ]}
    />
  );
};
